import { TError } from '../../types';
import { getErrorMessage } from '../../utils/getErrorMessage';

export function createApiActionError(error: unknown): TError {
  return { errorMessage: getErrorMessage(error) };
}
